import { cn } from '@/shared/ui/cn'

export type StatTileData = {
  value: string | number
  label: string
  color?: string
  onClick?: () => void
}

type StatTileProps = StatTileData & {
  className?: string
}

const TILE_BASE =
  'flex flex-col items-center justify-center rounded-md border bg-card/40 px-3 py-3'

export function StatTile({ value, label, color, onClick, className }: StatTileProps) {
  const content = (
    <>
      <span
        className="font-mono text-2xl font-semibold leading-none"
        style={color ? { color } : undefined}
      >
        {value}
      </span>
      <span className="mt-1.5 text-xs text-muted-foreground">{label}</span>
    </>
  )

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={cn(
          TILE_BASE,
          'text-center transition-colors hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
          className,
        )}
      >
        {content}
      </button>
    )
  }

  return <div className={cn(TILE_BASE, className)}>{content}</div>
}

type StatTilesProps = {
  tiles: StatTileData[]
  columns?: number
  className?: string
}

export function StatTiles({ tiles, columns = 3, className }: StatTilesProps) {
  return (
    <div
      className={cn('grid gap-2', className)}
      style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
    >
      {tiles.map((tile) => (
        <StatTile
          key={tile.label}
          value={tile.value}
          label={tile.label}
          color={tile.color}
          onClick={tile.onClick}
        />
      ))}
    </div>
  )
}
